module.exports = __webpack_public_path__ + "static/media/02.7d8fdffd.jpg";